<script setup lang="ts">

import { comma } from "@library/Utilities";
import { BasicMap, type IBasicMap } from "@app/Components/Google";
import type { ILocation } from '@domain/General/Location';
import type { IMarketplaceViewModel } from '@app/MyMarketplace/Types/IMarketplaceViewModel';

type Props = { viewModel: IMarketplaceViewModel }
const model = defineModel<ILocation>( { required: true } ); 
const { viewModel } = defineProps<Props>();

const distance = model.value.getDistance( viewModel.gpsLocation );

let map: IBasicMap = {
    size: { width: '4rem', height: '4rem' },
    center: model.value.toString(),
    zoom: 14,
    showMarker: false
};

</script>

<template>

    <JupiterButton type="map"
                   :to="model.toLatLng()"
                   class="flex text-left items-center gap-4 rounded-none p-4 3xl:p-6
                          bg-gray-50 dark:bg-gray-850">

        <div class="bg-white aspect-square w-16 rounded p-px overflow-hidden shrink-0">
            <BasicMap v-model="map" />
        </div>

        <div class="text-base 3xl:text-lg leading-tight">
            <div class="uppercase">Open in maps</div>
            <div class="opacity-60 text-[0.9em]">
                <span>{{ model.toString() }}</span>
                <span v-if="distance != null">, {{ comma( distance, 1 ) }}km</span>
            </div>
        </div>

    </JupiterButton>

</template>
